<ngx-loading [show]="loading"></ngx-loading>
<form (ngSubmit)="formSubmit()" [formGroup]="shipmentForm">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ shipment?.id ? 'Edit' : 'Add' }} Shipment</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="text-right mb-4" *ngIf="showFormSwitch">
      <mat-button-toggle-group name="selectedView" appearance="legacy"
                               [ngModelOptions]="{standalone: true}"
                               [(ngModel)]="selectedFormView"
                               (change)="changeFormView($event)">
        <mat-button-toggle value="regularTracking">Regular Tracking</mat-button-toggle>
        <mat-button-toggle value="enhancedTracking">Enhanced Tracking</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="container-fluid p-0" *ngIf="showPOField">
      <div class="row">
        <div class="col" *ngIf="!isPoCreation">
          <div class="form-group">
            <ng-select [placeholder]="isRCDSS ? 'Contract' : 'Purchase Order'"
                       bindValue="id"
                       bindLabel="po_number_supplier_name"
                       #po_number
                       [(ngModel)]="selectedPO"
                       (change)="selectPO($event)"
                       [clearable]="false"
                       [virtualScroll]="true"
                       [ngModelOptions]="{ standalone: true }"
                       [items]="purchaseOrders$ | async"
                       [addTag]="enablePoCreationBinded"
                       addTagText="Create new Purchase Order"
                       [compareWith]="comparePOs">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div title="item" [ngOptionHighlight]="search">{{item.customer_po_number}} ({{item.supplier_name}})
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col p-0" *ngIf="isPoCreation">
          <ngx-purchase-order-simple
            [isReducedView]="true"
            [poNumber]="poNumber"
            [poCreatedEventEmitter]="poCreatedEventEmitter">
          </ngx-purchase-order-simple>
        </div>
      </div>
    </div>

    <div class="container-fluid p-0" *ngIf="!showEnhanceTrackingForm">
      <div class="row">
        <div class="col">
          <mat-form-field>
            <input type="text"
                   autocomplete="off"
                   (change)="searchShipment($event)"
                   placeholder="Tracking Code" matInput formControlName="tracking_code">
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field>
            <input type="url"
                   required
                   secure-url-input
                   placeholder="Tracking Link" matInput formControlName="link">
          </mat-form-field>
        </div>

      </div>

      <div class="row">
        <div class="col">
          <mat-form-field>
            <input type="text"
                   placeholder="Date Shipped"
                   matInput
                   (focus)="shippedAtDatePicker.open()"
                   formControlName="shipped_at"
                   [matDatepicker]="shippedAtDatePicker">
            <mat-datepicker-toggle matSuffix [for]="shippedAtDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #shippedAtDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field>
            <input type="text"
                   placeholder="Expected Arrival"
                   matInput
                   [min]="shipmentForm.controls['shipped_at'].value"
                   (focus)="arrivesAtDatePicker.open()"
                   formControlName="arrives_at"
                   [matDatepicker]="arrivesAtDatePicker">
            <mat-datepicker-toggle matSuffix [for]="arrivesAtDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #arrivesAtDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field>
        <textarea placeholder="Description"
                  rows="3" formControlName="description" matInput></textarea>
          </mat-form-field>
        </div>
      </div>

    </div>
    <!--    <ngx-title-divider *ngIf="showEnhanceTrackingForm" title="Enhanced Tracking"></ngx-title-divider>-->

    <div class="row" *ngIf="showEnhanceTrackingForm">
      <div class="col-md-6">
        <mat-form-field>
          <mat-select placeholder="Carrier" formControlName="enhanced_tracking_carrier_id"
                      (selectionChange)="selectCarrier($event)">
            <mat-option *ngFor="let carrier of carriers" [value]="carrier.id">
              {{ carrier.official_name }} ({{ carrier.short_name }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- <div class="form-group">
          <ng-select placeholder="Carrier"
                  formControlName="enhanced_tracking_carrier_id"
                  bindValue="id"
                  bindLabel="official_name"
                  [(ngModel)]="selectedCarrier"
                  [clearable]="false"
                  [virtualScroll]="true"
                  [items]="carriers"> -->
        <!-- [ngModelOptions]="{ standalone: true }" -->
        <!-- (change)="selectCarrier($event)"> -->
        <!-- <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          <div title="item" [ngOptionHighlight]="search">{{item.official_name}} ({{item.short_name}})
          </div>
        </ng-template>
      </ng-select>
    </div> -->
      </div>
      <div class="col-md-3">
        <mat-form-field>
          <mat-select placeholder="Number Type" formControlName="enhanced_tracking_identifier_type">
            <mat-option *ngFor="let identifierType of selectedCarrier?.supported_identifier_types"
                        [value]="identifierType.value">
              {{ identifierType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field>
          <input type="text"
                 autocomplete="off"
                 placeholder="Number"
                 matInput
                 formControlName="enhanced_tracking_identifier" 
                 style="font-family: monospace !important; font-size: 16px;" />
        </mat-form-field>
      </div>
      <!-- <div class="col-12">
        <div class="alert alert-warning mb-3" *ngIf="shipmentForm.controls['enhanced_tracking_identifier']?.value">
          <i class="fa fa-warning"></i> Providing this field activates the enhanced ocean tracking for this container
          and will generate additional charges to your subscription.
        </div>
      </div> -->
    </div>

    <div class="row" *ngIf="showEnhanceTrackingForm">
      <div class="col-md-12">
        <mat-form-field class="references" appearance="fill">
          <mat-label>References</mat-label>
          <mat-chip-list #referencesList aria-label="References">
            <mat-chip *ngFor="let reference of references" (removed)="removeReference(reference)">
               <!-- [color]="reference?.color || defaultColor" -->
              {{reference}}
              <button style="display: contents;" matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input placeholder="Type here..."
                   [disabled]="!purchaseOrder"
                   [matChipInputFor]="referencesList"
                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                   [matChipInputAddOnBlur]="addOnBlur"
                   (matChipInputTokenEnd)="addReference($event)">
          </mat-chip-list>
        </mat-form-field> 
      </div> 
    </div>

    <div class="my-4" *ngIf="!showEnhanceTrackingForm">
      <div class="file-row" style="height: unset;" *ngIf="!currentShipment">
        <div class="add-file text-center">
          <label class="btn btn-link">
              <span class="file-icon">
                <i class="fa fa-paperclip"></i>
              </span>
            {{ shipment?.id ? 'Change' : 'Add' }} file
            <input type="file" (change)="addFile($event)" style="display:none;" />
          </label>
        </div>
      </div>
      <div class="files-list" *ngIf="filesObject">

        <div class="file-item mb-2" *ngFor="let fileItem of filesObject; let $index = index;">
          <div class="d-flex col-md-12 justify-content-center">
            <div class="document-icon">
              <i class="fa fa-file"></i>
            </div>
            <div class="file-info-container mx-4">
              {{fileItem.name }} - {{ fileItem.size | fileSize }}
            </div>
            <a class="clickable">
              <i class="fa fa-close" (click)="removeFile(fileItem, $index)"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="files-list" *ngIf="filesUploaded">

        <div class="file-item mb-2" *ngFor="let fileItem of filesUploaded; let $index = index;">
          <div class="d-flex col-md-12 justify-content-center">
            <div class="document-icon">
              <i class="fa fa-file"></i>
            </div>
            <div class="d-flex flex-column text-center">
              <a class="file-info-container mx-4" (click)="getFile(fileItem.file)">
                {{fileItem.file.file_name }}
              </a>
              {{ fileItem.file.file_size | fileSize }}
            </div>
            <a class="clickable">
              <i class="fa fa-close" (click)="removeFile(fileItem, $index)"></i>
            </a>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="!showEnhanceTrackingForm">
      <h5>Line Items</h5>

      <div class="mb-2" [formGroup]="shipmentLineItemsForm">
        <div class="row">
          <div class="col">
            <mat-form-field>
              <mat-select
                placeholder="Select an item"
                [required]="!selectedLineItems.length"
                formControlName="line_item_id">
                <mat-option
                  [value]="item.id"
                  *ngFor="let item of lineItemsFiltered$ | async">
                  {{ item.product_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!--<div class="form-control border-0 pl-0 pr-0">
              <ng-select
                [items]="lineItemsFiltered$ | async"
                [typeahead]="lineItems$"
                [clearable]="false"
                formControlName="line_item_id"
                bindValue="id"
                bindLabel="product_name"
                required
                placeholder="Product"
                typeToSearchText="Select Product on the Purchase Order"
              >
              </ng-select>
            </div>-->
          </div>

          <div class="col">
            <mat-form-field>
              <input type="number"
                     min="1"
                     [required]="!selectedLineItems.length"
                     placeholder="Quantity Shipped" matInput formControlName="quantity_shipped">
            </mat-form-field>
          </div>

          <div class="col-sm-2">
            <button type="button" class="btn btn-primary"
                    [disabled]="shipmentLineItemsForm.invalid || (!shipmentLineItemsForm.get('line_item_id').value && !shipmentLineItemsForm.get('quantity_shipped').value)"
                    (click)="addShipmentLineItem()">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="mb-2"
           *ngFor="let item of selectedLineItems; let i = index">
        <div class="row d-flex align-items-center">
          <div class="col">
            {{ item.name }}
          </div>
          <div class="col-2">
            <!--            {{ item.quantity_shipped }}-->
            <input
              class="form-control text-right"
              type="number"
              min="1"
              [(ngModel)]="item.quantity_shipped"
              [ngModelOptions]="{standalone:true}"
              [required]="!selectedLineItems.length"
              placeholder="Quantity Shipped" />
          </div>

          <div class="col-sm-2">
            <a type="button" class="btn btn-link text-danger p-0" (click)="removeShipmentLineItem(item, i)">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button class="btn btn-primary"
            [disabled]="shipmentForm.invalid || !purchaseOrder">
      Save
    </button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
  </div>
</form>
